import { NavLink } from "react-router-dom";
import styled from "styled-components";

export const RecommendationPosterCardContainer = styled(NavLink)`
  display: flex;
  flex-direction: column;
  text-decoration: none;
`;

export const RecommendationArticleCardImgContainer = styled.div`
  position: relative;
  width: 100%;
`;

export const RecommendationCardContainer = styled(NavLink)<{
  render: TRecommendationItemsRender;
  colortheme: TColorsTheme;
}>`
  text-decoration: none;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background-color: ${({ colortheme, theme }) =>
    colortheme === "dark"
      ? theme.colorsPalette.black.light
      : theme.colorsPalette.white.default};
  border: 1px solid
    ${({ colortheme, theme }) =>
      colortheme === "dark"
        ? theme.colorsPalette.black.lighter
        : theme.colorsPalette.white.default};
  overflow: hidden;

  p,
  b  {
    &:last-child {
      margin-bottom: 24px;
    }
  }

  ${({ render }) => {
    switch (render) {
      case "poster":
      case "portrait":
        return `
          margin-top: 8px;
          height: 156px;         
       `;

      default:
        return ``;
    }
  }}
`;

export const RecommendationItemCardImg = styled.img<{
  render: TRecommendationItemsRender;
}>`
  object-fit: cover;

  ${({ render }) => {
    switch (render) {
      case "article":
        return `
          display: inline;
          height: 200px;
          width: 100%;
          object-fit: cover;
          border-top-right-radius: 8px;
          border-top-left-radius: 8px;
        `;

      case "poster":
        return `
          height: 100%;
          width: 100%;
        `;

      case "portrait":
        return `
          height: 132px;
          border-radius: 8px;
        `;

      default:
        return ``;
    }
  }}
`;
